import './action-bar.scss';

import { defineComponent } from 'vue';
import { faClock, faListAlt } from '@fortawesome/free-regular-svg-icons';
import {
    faClock as faSolidClock,
    faCogs,
    faHome,
    faListAlt as faSolidListAlt,
    faWifi,
    faSlash,
    faExclamation,
} from '@fortawesome/free-solid-svg-icons';

import { ConditionReportRoutes } from '@skinsoft/const';
import { OfflineDataFetcher, OfflineDataUpdateCacher } from '@skinsoft/offline';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { SideMenu } from '@skinsoft/ui';
import { SynchroModal } from '@skinsoft/offline-mode';
import { OnlineStatusIndicator } from '@skinsoft/offline-mode/src/components/online-status-indicator';
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics';
import { FORCE_CLOSE_MENU_TOPIC } from '../../../busTopics';

export const ActionBar = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSideMenu: SideMenu,
        sSynchroModal: SynchroModal,
        sOnlineStatusIndicator: OnlineStatusIndicator,
    },
    template: require('./action-bar.html'),
    data() {
        return {
            homeIcon: faHome,
            menuIcon: faCogs,
            clockIcon: faClock,
            solidClockIcon: faSolidClock,
            listIcon: faListAlt,
            solidListIcon: faSolidListAlt,
            wifiIcon: faWifi,
            slashIcon: faSlash,
            errorIcon: faExclamation,

            movementCount: 0,
            taskCount: 0,
            menuOpened: false,
            routeHasMenu: false,

            toggleSideMenuTopic: TOGGLE_MENU_TOPIC,
            forceCloseMenuTopic: FORCE_CLOSE_MENU_TOPIC,
            isSyncError: false,
        }
    },
    created() {
        this.subscribeToBus(TOGGLE_MENU_TOPIC, () => {
            this.menuOpened = !this.menuOpened;
        })
    },
    methods: {
        goToCurrentReports() {
            this.$router.push({ name: ConditionReportRoutes.CURRENT_REPORTS });
        },

        goToCloseReports() {
            this.$router.push({ name: ConditionReportRoutes.CLOSE_REPORTS });
        },

        goToSearch() {
            this.$router.push({ name: ConditionReportRoutes.CONDITION_REPORT_HOME })
        },

        toggleMenu() {
            this.emitOnBus(TOGGLE_MENU_TOPIC);
        },

        toogleSynchroModal() {
            (this.$refs.synchroModal as InstanceType<typeof SynchroModal>).open();
        },

        async fetchSyncError() {
            this.isSyncError = await OfflineDataUpdateCacher.isPushError() || await OfflineDataFetcher.isSyncError();
        },

        checkCurrentRoute(routeName) {
            return this.$route.path === routeName;
        },
    },
    watch: {
        '$route': {
            handler($route) {
                this.routeHasMenu = !!$route.matched.find(match => !!match.components.actionMenu);
                if (!this.routeHasMenu) {
                    this.emitOnBus(FORCE_CLOSE_MENU_TOPIC);
                    this.menuOpened = false;
                }
            },
            immediate: true,
            deep: true,
        },
    },
})
